'use client';

import { createContext, useContext, type ReactNode } from 'react';

/**
 * The live businesses-scanned count for the closing scan panel. A route
 * segment's layout supplies it once through `ScanCountBoundary` (server), so
 * the interior pages and their articles never thread the number through props.
 * `null` means no provider is mounted – an isolated render – and the panel then
 * omits its count line rather than showing an invented number.
 */
const ScanCountContext = createContext<number | null>(null);

export function ScanCountProvider({
  count,
  children,
}: {
  count: number;
  children: ReactNode;
}): React.ReactElement {
  return <ScanCountContext.Provider value={count}>{children}</ScanCountContext.Provider>;
}

export function useScanCount(): number | null {
  return useContext(ScanCountContext);
}
